import React from 'react'

export default function Error() {
    return (
        <div className="errorPage">
            <h1>Oops! This page doesn't exist</h1>
        </div>
    )
}
